/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export let RouteChangeType = /*#__PURE__*/function (RouteChangeType) {
  /** Current route handler and view component will both be unloaded, new route handler and view component mounted */
  RouteChangeType[RouteChangeType["MAJOR"] = 0] = "MAJOR";
  /** Current route handler remains the same and view component will be sent new props */
  RouteChangeType[RouteChangeType["MINOR"] = 1] = "MINOR";
  /**
   * @deprecated Legacy BRE Case where two different routes use the same underlying view component, and
   * do not want the view component to be unmounted as part of the route change.
   * Current route handler will be unmounted, new route handler will be mounted,
   * and view component will be sent new props.
   */
  RouteChangeType[RouteChangeType["MID"] = 2] = "MID"; // short for 'Middling' which is somewhere between Major and Minor...
  return RouteChangeType;
}({});
export let ContinueRouteChangeType = /*#__PURE__*/function (ContinueRouteChangeType) {
  /** Will continue the route change */
  ContinueRouteChangeType[ContinueRouteChangeType["CONTINUE"] = 1] = "CONTINUE";
  /** Will cancel the route change, and will NOT invoke the retry route change workflow */
  ContinueRouteChangeType[ContinueRouteChangeType["CANCEL"] = 2] = "CANCEL";
  /** Will cancel the route change, but invoke the retryRouteChange workflow (typically save/discard/cancel dialog) */
  ContinueRouteChangeType[ContinueRouteChangeType["CANCEL_AND_RETRY"] = 3] = "CANCEL_AND_RETRY";
  return ContinueRouteChangeType;
}({});
export class RouteChangeContext {
  constructor(newReactRoute, newRegisteredRoute, routeRenderContext, browserInitiated, /** True if route change initiated by browser url change (back/forward/bookmark/edit), and false if code initiated */
  addToBrowserHistory, /* true if current url should be pushed onto browser history stack */
  routeChangeType,
  /**
   * Cached result of calling currentRouteHandler.isMajorRouteChange(newRouteState),
   * (unless currentRouteHandler is null, in which case it is true)
   */
  historyInitiatedFn) {
    this.newReactRoute = newReactRoute;
    this.newRegisteredRoute = newRegisteredRoute;
    this.routeRenderContext = routeRenderContext;
    this.browserInitiated = browserInitiated;
    this.addToBrowserHistory = addToBrowserHistory;
    this.routeChangeType = routeChangeType;
    this.historyInitiatedFn = historyInitiatedFn;
  }
}
//# sourceMappingURL=RouteChangeContext.js.map
